// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__21w1z","col":"styles_col__mxe2E"};